import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { OfferCounter, OfferCounterItem, Spinner } from 'telia-front-react';
import MovieDetailsStore, { MovieDetails } from '../stores/movierental/MovieDetailsStore';
import { ContentType } from '../stores/movierental/MovieRentalCatalogStore';
import RouteStore from '../stores/RouteStore';
import { isHtml } from '../util/TextUtil';
import MovieRentalCard from './MovieRentalCard';
import TvModal from './TvModal';

export interface TvTopItem {
  id: number;
  title?: string;
  poster?: string;
}

export interface TvTopItemReference extends TvTopItem {
  type: ContentType;
}

export interface TvTopProps {
  rootCategoryId: string;
  items: (TvTopItem | TvTopItemReference | number)[];
  type?: ContentType;
  isFreeOfCharge?: boolean;
  movieDetailsStore?: MovieDetailsStore;
  darkBackground?: boolean;
  specialPricePacketIds?: number[];
  routeStore?: RouteStore;
}

@observer
class TvTop extends React.Component<TvTopProps> {
  public componentDidMount() {
    const { movieDetailsStore, items, type } = this.props;
    Promise.all([items.map((item) => movieDetailsStore.loadMovieDetails(this.getItemId(item), this.getItemType(item, type)))]);
  }

  private isFetching() {
    const { movieDetailsStore, items, type } = this.props;
    return items.find((item) => movieDetailsStore.isFetchingMovieDetails(this.getItemId(item), this.getItemType(item, type)));
  }

  private getItemId(item: TvTopItem | TvTopItemReference | number) {
    if (typeof item === 'object') {
      return item.id;
    }
    return item;
  }

  private getItemType(item: TvTopItem | TvTopItemReference | number, type: string) {
    // eslint-disable-next-line no-prototype-builtins
    if (item?.hasOwnProperty('type')) {
      // @ts-ignore
      return item.type;
    }
    return type;
  }

  private mapDetailsToMovie(details: MovieDetails) {
    const { type, items } = this.props;
    const customDetails = items.find((item) => typeof item === 'object' && item.id === details.id) as TvTopItem;
    details = { ...details, ...customDetails };
    const { id, title, originalTitle, images } = details;
    return {
      id,
      name: title,
      type: this.getItemType(customDetails, type),
      originalName: originalTitle,
      images: images
    };
  }

  private getMovies() {
    const { movieDetailsStore, items, type } = this.props;
    return items
      .map((item) => movieDetailsStore.getMovieDetails(this.getItemId(item), this.getItemType(item, type)))
      .filter((movie) => movie && movie.id && movie.title && movie.images)
      .map((details) => this.mapDetailsToMovie(details));
  }

  public render() {
    const { darkBackground } = this.props;

    if (this.isFetching()) {
      return <Spinner />;
    }

    return (
      <>
        <OfferCounter>
          {this.getMovies().map((movie) => (
            <OfferCounterItem key={movie.id} className="text">
              <MovieRentalCard movie={movie} darkBackground={darkBackground} htmlTitle={isHtml(movie.name)} />
            </OfferCounterItem>
          ))}
        </OfferCounter>
        <TvModal {...this.props} />
      </>
    );
  }
}

export default inject('movieDetailsStore', 'routeStore')(TvTop);
